import { atom, useAtomValue, useSetAtom } from 'jotai';
import { isInElectron } from 'utils/is';
import { isMasterOnline, isSiteGiant } from '../../productLine.ts';

const detectClientModalVisibleState = atom(false);

export const useDetectClientModal = () => {
  const visible = useAtomValue(detectClientModalVisibleState);
  const setVisible = useSetAtom(detectClientModalVisibleState);

  return {
    visible,
    show: () => setVisible(true),
    hide: () => setVisible(false),
    detectClient: () => {
      if (isInElectron || isMasterOnline || isSiteGiant) {
        return true;
      }
      setVisible(true);
      return false;
    },
  };
};
